<script>
/* eslint-disable no-unused-vars */
import "./addBox.scss";
import { NextNode } from "@/components/DrawFlow/src/components/DrawAddSelectBox/NextNode";
export default {
  name: "AddBox",
  props: {
    nodeConfig: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      boxArr: [
        {
          type: "2",
          value: "审批人",
          isRow: true,
          calssName: "approver",
          icon: "el-icon-user"
        },
        {
          type: "4",
          value: "抄送人",
          isRow: true,
          calssName: "notifier",
          icon: "el-icon-edit"
        },
        {
          type: "5",
          value: "办理人",
          isRow: true,
          calssName: "notifier",
          icon: "el-icon-s-promotion"
        },
        {
          type: "3",
          value: "条件分支",
          isRow: false,
          calssName: "route",
          icon: "el-icon-s-operation"
        },
        // {
        //   type: "6",
        //   value: "阻止创建分支",
        //   isRow: false,
        //   calssName: "route",
        //   icon: "el-icon-s-operation"
        // }
      ]
    };
  },
  methods: {
    clickSelectBox(item) {
      this.getNexttBox(item);
    },
    getNexttBox(item) {
      console.log("item点击某一个新增按钮", item)
      const nodeConfig = this.nodeConfig;
      let { id, prevId, type, isRow, title } = Object.assign(
        {},
        nodeConfig,
        item
      );
      let nextNode = new NextNode({ id, prevId, type, isRow, title });
      console.log("nextNode", nextNode)
      this.$emit("clickSelectBox", nextNode, nodeConfig);
    },
    renderAddSBox() {
      return (
        <div class="add-node-popover">
          <div class="add-node-popover-body">
            {this.boxArr.map(item => {
              return (
                <a
                  onClick={() => {
                    this.clickSelectBox(item);
                  }}
                  class={["add-node-popover-item", item.calssName]}
                >
                  <div class="item-wrapper">
                    <i class={`iconfont ` + item.icon}></i>
                  </div>
                  <span>{item.value}</span>
                </a>
              );
            })}
          </div>
        </div>
      );
    }
  },
  render() {
    return this.renderAddSBox();
  }
};
</script>
